import styled from "styled-components";
import CurrencySelect from "./menuButtons/CurrencySelect";
import LoggedOutDropdown from "./menuButtons/LoggedOutDropdown";
import LoginRegisterButtons from "./menuButtons/LoginRegisterButtons";
import { Nav } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const StyledNav = styled(Nav)`
  gap: 0.5rem;
`;

const LoggedOutMenu = () => {
  const location = useLocation();

  return (
    <StyledNav className="align-items-center">
      <CurrencySelect />

      {location.pathname.toLowerCase() === "/" && <LoginRegisterButtons />}

      <LoggedOutDropdown />
    </StyledNav>
  );
};

export default LoggedOutMenu;
